import { render, staticRenderFns } from "./logistics_home.vue?vue&type=template&id=ccf942a4&scoped=true&"
import script from "./logistics_home.vue?vue&type=script&lang=js&"
export * from "./logistics_home.vue?vue&type=script&lang=js&"
import style0 from "./logistics_home.vue?vue&type=style&index=0&id=ccf942a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf942a4",
  null
  
)

export default component.exports